export const DOC_TYPES = {
  quotation: { prefix: "QTN", label: "Quotation", party: "customer", path: "quotations", showTax: true, showTransport: false },
  sales_order: { prefix: "SO", label: "Sales Order", party: "customer", path: "sales-orders", showTax: true, showTransport: false, showDelivery: true, showAdvance: true, canConvertToInvoice: true, listItems: true, defaultStatusFilter: "pending", sortByDelivery: true },
  purchase_order: { prefix: "PO", label: "Purchase Order", party: "vendor", path: "purchase-orders", showTax: true, showTransport: false, showDelivery: true },
  invoice: { prefix: "INV", label: "Tax Invoice", party: "customer", path: "invoices", showTax: true, showTransport: true, showEway: true, showPayments: true, showAdvance: true, canCreditNote: true, canConvertToGatePass: true },
  repair_invoice: { prefix: "RI", label: "Repair Invoice", party: "customer", path: "repair-invoices", showTax: true, showTransport: false, showRepair: true, showPayments: true, showAdvance: true, showDelivery: true, canConvertToInvoice: true, canCreditNote: true, canConvertToGatePass: true },
  delivery_challan: { prefix: "DC", label: "Delivery Challan", party: "customer", path: "delivery-challans", showTax: true, showTransport: true, canConvertToInvoice: true, canConvertToGatePass: true },
  gate_pass: { prefix: "GP", label: "Gate Pass", party: "customer", path: "gate-passes", showTax: true, showTransport: true, showGatePass: true },
  job_work_challan: { prefix: "JWC", label: "Job Work Challan", party: "vendor", path: "job-work-challans", showTax: true, showTransport: true, showJobWork: true, canConvertToGatePass: true },
  credit_note: { prefix: "CN", label: "Credit Note", party: "customer", path: "credit-notes", showTax: true, showTransport: false, isAdjustment: true },
  debit_note: { prefix: "DN", label: "Debit Note", party: "vendor", path: "debit-notes", showTax: true, showTransport: false, isAdjustment: true },
};

export const DOC_TYPE_BY_PATH = Object.fromEntries(
  Object.entries(DOC_TYPES).map(([k, v]) => [v.path, k])
);

export const INDIAN_STATES = [
  { code: "01", name: "Jammu & Kashmir" },
  { code: "02", name: "Himachal Pradesh" },
  { code: "03", name: "Punjab" },
  { code: "04", name: "Chandigarh" },
  { code: "05", name: "Uttarakhand" },
  { code: "06", name: "Haryana" },
  { code: "07", name: "Delhi" },
  { code: "08", name: "Rajasthan" },
  { code: "09", name: "Uttar Pradesh" },
  { code: "10", name: "Bihar" },
  { code: "11", name: "Sikkim" },
  { code: "12", name: "Arunachal Pradesh" },
  { code: "13", name: "Nagaland" },
  { code: "14", name: "Manipur" },
  { code: "15", name: "Mizoram" },
  { code: "16", name: "Tripura" },
  { code: "17", name: "Meghalaya" },
  { code: "18", name: "Assam" },
  { code: "19", name: "West Bengal" },
  { code: "20", name: "Jharkhand" },
  { code: "21", name: "Odisha" },
  { code: "22", name: "Chhattisgarh" },
  { code: "23", name: "Madhya Pradesh" },
  { code: "24", name: "Gujarat" },
  { code: "25", name: "Daman & Diu" },
  { code: "26", name: "Dadra & Nagar Haveli" },
  { code: "27", name: "Maharashtra" },
  { code: "28", name: "Andhra Pradesh (Old)" },
  { code: "29", name: "Karnataka" },
  { code: "30", name: "Goa" },
  { code: "31", name: "Lakshadweep" },
  { code: "32", name: "Kerala" },
  { code: "33", name: "Tamil Nadu" },
  { code: "34", name: "Puducherry" },
  { code: "35", name: "Andaman & Nicobar" },
  { code: "36", name: "Telangana" },
  { code: "37", name: "Andhra Pradesh" },
  { code: "38", name: "Ladakh" },
];

export const STATUS_OPTIONS = ["draft", "pending", "sent", "accepted", "completed", "rejected", "cancelled", "paid", "partial", "dispatched"];

// Per doc_type, restrict the status dropdown to a clean workflow set.
export const DOC_STATUS_OPTIONS = {
  sales_order: ["pending", "completed", "cancelled"],
  repair_invoice: ["pending", "completed", "cancelled"],
};

export function statusClass(status) {
  switch ((status || "").toLowerCase()) {
    case "paid":
    case "accepted":
    case "completed":
    case "dispatched":
      return "status-success";
    case "partial":
    case "sent":
      return "status-info";
    case "cancelled":
    case "rejected":
      return "status-error";
    case "draft":
    case "pending":
      return "status-warning";
    default:
      return "status-neutral";
  }
}

export const UNITS = ["NOS", "KG", "LTR", "BAG", "BOX", "MT", "PCS", "MTR", "CTN", "PKT"];

// Strip spaces/dots/dashes from pasted GSTINs, uppercase, cap at 15 alphanumerics
export const sanitizeGstin = (v) => String(v || "").replace(/[^0-9A-Za-z]/g, "").toUpperCase().slice(0, 15);

export const INDIAN_CITIES = [
  "Meerut", "New Delhi", "Mumbai", "Bengaluru", "Bangalore", "Chennai", "Kolkata", "Hyderabad", "Pune",
  "Ahmedabad", "Surat", "Jaipur", "Lucknow", "Kanpur", "Nagpur", "Indore", "Thane", "Bhopal", "Visakhapatnam",
  "Patna", "Vadodara", "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Faridabad", "Rajkot", "Varanasi", "Srinagar",
  "Aurangabad", "Dhanbad", "Amritsar", "Allahabad", "Prayagraj", "Howrah", "Coimbatore", "Jabalpur", "Gwalior",
  "Vijayawada", "Jodhpur", "Madurai", "Raipur", "Kota", "Chandigarh", "Guwahati", "Solapur", "Hubli", "Mysore",
  "Tiruchirappalli", "Bareilly", "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Bikaner", "Amravati",
  "Noida", "Jamshedpur", "Bhilai", "Cuttack", "Firozabad", "Kochi", "Ernakulam", "Bhavnagar", "Dehradun",
  "Durgapur", "Asansol", "Nanded", "Kolhapur", "Ajmer", "Gulbarga", "Jamnagar", "Ujjain", "Loni", "Siliguri",
  "Jhansi", "Ulhasnagar", "Nellore", "Jammu", "Sangli", "Belgaum", "Mangalore", "Tirunelveli", "Malegaon",
  "Gaya", "Jalgaon", "Udaipur", "Maheshtala", "Davanagere", "Kozhikode", "Akola", "Kurnool", "Rajpur Sonarpur",
  "Bokaro", "South Dumdum", "Bellary", "Patiala", "Gopalpur", "Agartala", "Bhagalpur", "Muzaffarnagar",
  "Bhatpara", "Panihati", "Latur", "Dhule", "Rohtak", "Korba", "Bhilwara", "Berhampur", "Muzaffarpur", "Ahmednagar",
  "Mathura", "Kollam", "Avadi", "Kadapa", "Kamarhati", "Bilaspur", "Shahjahanpur", "Satara", "Bijapur", "Rampur",
  "Shivamogga", "Chandrapur", "Junagadh", "Thrissur", "Alwar", "Bardhaman", "Kulti", "Kakinada", "Nizamabad",
  "Parbhani", "Tumkur", "Khammam", "Ozhukarai", "Bihar Sharif", "Panipat", "Darbhanga", "Bally", "Aizawl",
  "Dewas", "Ichalkaranji", "Karnal", "Bathinda", "Jalna", "Eluru", "Kirari Suleman Nagar", "Barasat",
  "Purnia", "Satna", "Mau", "Sonipat", "Farrukhabad", "Sagar", "Rourkela", "Durg", "Imphal", "Ratlam",
  "Hapur", "Arrah", "Karimnagar", "Anantapur", "Etawah", "Ambernath", "North Dumdum", "Bharatpur", "Begusarai",
  "Gandhinagar", "Baranagar", "Tiruvottiyur", "Pondicherry", "Sikar", "Thoothukudi", "Rewa", "Mirzapur",
  "Raichur", "Pali", "Ramagundam", "Haridwar", "Vijayanagaram", "Tenali", "Nagercoil", "Sri Ganganagar",
  "Karawal Nagar", "Mango", "Thanjavur", "Bulandshahr", "Uluberia", "Murwara", "Sambhal", "Singrauli",
  "Nadiad", "Secunderabad", "Naihati", "Yamunanagar", "Bidhannagar", "Pallavaram", "Bidar", "Munger",
  "Panchkula", "Burhanpur", "Raurkela", "Kharagpur", "Dindigul", "Gandhidham", "Hospet", "Nangloi Jat",
  "Malda", "Ongole", "Deoghar", "Chapra", "Haldia", "Khandwa", "Nandyal", "Morena", "Amroha", "Anand",
  "Bhind", "Bhalswa Jahangir Pur", "Madhyamgram", "Bhiwani", "Berhampore", "Ambala", "Morbi", "Fatehpur",
  "Raebareli", "Mahbubnagar", "Mira-Bhayandar", "Vasai-Virar", "Khanna", "Karaikudi", "Kishangarh",
  "Jamalpur", "Ballia", "Kishanganj", "Mainpuri", "Etah", "Ratnagiri", "Sasaram", "Hajipur", "Gondia",
  "Wardha", "Yavatmal", "Buldhana", "Akot", "Chiplun",
];
